import React from "react";
import { LayoutIndex } from "@/routers/constant";
import { RouteObject } from "@/routers/interface";
import MenuIcon from "@/routers/menu_icon";
import icon from "@/assets/icons/menu/分析.png";
import DataAnalysis from "@/pages/Data";

// 数据概览模块
const dataRouter: Array<RouteObject> = [
    {
        element: <LayoutIndex />,
        path: "/data",
        meta: {
            title: "数据概览",
        },
        icon: <MenuIcon src={icon} />,
        children: [
            {
                path: "/data/analysis",
                element: <DataAnalysis />,
                meta: {
                    requiresAuth: true,
                    title: "数据概览",
                    key: "data-analysis"
                }
            }
        ]
    }
];

export default dataRouter;
